<router-view></router-view><AppAlerts></AppAlerts>